export default "__VITE_ASSET__328696ea__"